import styled, { css } from 'styled-components';
import Calendar from 'react-calendar';
import { Calendar as CalendarIcon } from 'react-feather';

import { Page, Row } from 'components/shared/Layout';
import Button from 'components/ui/Button';
import Select from 'components/ui/Select';

import { colours } from 'themes/default';

export const StyledForm = styled.form`
  display: flex;
  width: auto;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
`;

export const StyledHeading = styled.h1`
  display: inline-block;
  margin-bottom: 20px;
`;

export const StyledPage = styled(Page)`
  padding: 40px;
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;

  ${({ mandatory }) =>
    mandatory
      ? css`
          &::after {
            content: ' *';
            color: ${colours.Messaging.ErrorRed};
          }
        `
      : ''}
`;

export const StyledSelect = styled(Select)`
  border-radius: 5px;
  height: 38px;
`;

export const FormContainer = styled.div`
  background: ${colours.Greyscale.MistGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  padding: 20px;
`;

export const FormContainerDate = styled.div`
  background: ${colours.Greyscale.MistGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  padding: 20px;
  display: flex;
  align-items: center;
`;

export const ErrorMessage = styled.span`
  color: red;
  display: block;
`;

export const StyledInputFields = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledRowFields = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 16px;
`;

export const StyledPassengerDetails = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  height: fit-content;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
`;

export const StyledPriceField = styled.div`
  flex-grow: 0;
`;

export const StyledDateField = styled.div`
  margin-right: 20px;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  & input:hover {
    cursor: pointer;
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 10px;
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  margin-right: 5px;
  position: absolute;
  right: 6px;
  top: 8px;
`;

export const StyledCalendar = styled(Calendar)`
  &.react-calendar {
    width: 25%;
  }

  .react-calendar__tile-away-dates {
    background-color: ${colours.Shades.BlueShade20};
  }
`;

export const StyledH2 = styled.h2`
  font-size: 18px;
  font-weight: normal;
  margin: 0;
`;

export const ThalysPassDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledRadio = styled.input`
  margin-right: 5px;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const StyledRowRadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const StyledButton = styled(Button)`
  height: 36px;
  border-radius: 5px;
`;

export const RedirectButton = styled(Button)`
  display: block;
  margin: auto;
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
`;

export const PassengerDetailsFieldsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`;

export const VatDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
